import { AppData, Img, Lightning, Log, Registry, Router, Utils } from '@lightningjs/sdk'
import { AppSetup } from '../lib/app-setup'
import { AppApiConfig } from '../lib/app-api-config'
import GridViewModel, { FocusInfo } from '../lib/components/grid/grid-view-model'
import MultiRowGrid from '../lib/components/grid/multirow-grid'
import InfoUI from '../ui-elements/info-ui'
import { ItemNode } from "../lib/components/grid/ItemNode"
import { Logger } from '../lib/logger'
import { Helper } from '../lib/helper'
import { KeyCodes } from '../lib/key-codes'
import { DIALOG_BUTTON_ACTION, DIALOG_TYPE } from '../lib/enum'
import { IDialogueInfo } from '../lib/interfaces'
import { Autoplay } from '../lib/autoplay'
import BackBarUI from '../ui-elements/back-bar'
import childApp from '../lib/child-app'


export interface MLPGridTemplateSpec extends Lightning.Component.TemplateSpecLoose {
  Background: object
  focusRow: number
  RowListWrapper: object
  MultiRowGrid: object
}

export interface MLPGridTypeConfig extends Lightning.Component.TypeConfig {
  IsPage: true
}

export default class MLPGrid
  extends Lightning.Component<MLPGridTemplateSpec, MLPGridTypeConfig>
  implements Lightning.Component<MLPGridTemplateSpec> {
  Background = this.getByRef('Background')!
  RowListWrapper = this.getByRef('RowListWrapper')!
  MultiRowGrid = this.getByRef('MultiRowGrid')!
  Logo = this.getByRef('Logo')!

  gridViewModel!: GridViewModel
  focusRow = 0
  isMenuFocused = false
  autoPlay!: Autoplay
  autoPlayStoppedByBack = false

  loadingTimeoutId = null;

  longPressTimestamp = 0;
  isKeyDown = false;

  static override _template(): Lightning.Component.Template<MLPGridTemplateSpec> {
    return {
      ...super._template(),
      w: 1920,
      h: 1080,
      rect: true,
      color: 0xff222222,
      Background: {
        rect: true,
        collision: true,
        w: 1920,
        h: 1080,
        color: 0xff222222,
      },
      ItemInfo: {
        w: 1920,
        h: 1080,
        type: InfoUI,
      },
      RowListWrapper: {
        x: 0,
        y: 540,
        w: 1920,
        h: 540,
        boundsMargin: [200, 200, 800, 800],
        clipping: true,
        collision: true,
        MultiRowGrid: undefined
      },
      BackBar: {
        x: 0,
        y: 0,
        type: BackBarUI,
        zIndex: 65,
        collision: true,
      },
    }
  }

  override _getFocused():
    | Lightning.Component<Lightning.Component.TemplateSpecLoose, Lightning.Component.TypeConfig>
    | null
    | undefined {
    Log.info('MLPGridTemplateSpec: _getFocused fired')
    return this.tag('MultiRowGrid')
  }

  override _active(): void {
    Router.focusPage()
  }

  override _focus(): void {
    Log.info('MLPGridTemplateSpec: _focus fired')
    this.autoPlay?.userInteracted(true)
  }

  override _unfocus(): void {
    this.updateAutoPlayVideo(false)
  }

  reloadGrid() {
    this.tag('MultiRowGrid').reloadGrid()
  }

  resetFocus(focusObj: FocusInfo) {
    this.tag('MultiRowGrid').resetFocus(focusObj)
  }

  /*override _handleInfo(e: KeyboardEvent): boolean | void {
    Log.info('MainGridTemplateSpec: _handleInfo ', e)
    Router.focusWidget('OptionsMenu')
    return true
  }*/
  override _handleKey(e: KeyboardEvent): boolean | void {
    Log.info('MLPGridTemplateSpec: _handleKey ', e)
    const { platform } = AppData as AppSetup
    //XFIN-162 - Comcast - Implement alternative way to open star menu for PlatCo
    //Open option menu when 0 is pressed.
    if (e.keyCode == KeyCodes.KEY_LONG_OK) {
      this.autoPlay?.userInteracted(false)
      this.$handleLongEnter()
      return true
    }
    if (platform?.isOptionsKey(e)) {
      this.autoPlay?.userInteracted(false)
      platform?.textToSpeach('Opening Options Menu')
      Router.focusWidget('OptionsMenu')
      return true
    }
    if(e.keyCode == KeyCodes.KEY_EXIT) {
      this.autoPlay?.userInteracted(false)
      const { appState } = AppData as AppSetup
      const app = appState?.getApp()
      app?.handleAppExit()
      return true
    }
    // if (Helper.getAppType() &&
    //   (Helper.getAppType().indexOf('platco') > -1 ||
    //     Helper.getAppType().indexOf('vizio') > -1)
    // ) {
    //   if (e.code == 'Digit0') {
    //     Router.focusWidget('OptionsMenu')
    //     return true
    //   }
    // } else {
    //   if (e.code == 'KeyI') {
    //     Router.focusWidget('OptionsMenu')
    //     return true
    //   }
    // }
    return false
  }

  _gridLoadedHandler(event: any) {
    Log.info('MLPGridTemplateSpec: gridViewModel: _gridLoadedHanlder: ', event)
    Log.info('MLPGridTemplateSpec: gridViewModel: ', this.gridViewModel)
    this.patch({
      RowListWrapper: {
        MultiRowGrid: {
          x: 163,
          y: 0,
          w: (w: any) => w,
          h: (h: any) => h,
          grid: this.gridViewModel,
          collision: true,
          //item: this.gridViewModel,
          type: MultiRowGrid,
        }
      }
    })
    this.loadingTimeoutId = Registry.setTimeout(() => {
      this.widgets.loadingscreen.showL1LoadingScreen(false)
      this.initAutoplay()
      this.autoPlay && this.autoPlay?.userInteracted(true)
    }, 1000)
  }

  _gridFocusedHandler(event: any) {
    const { platform } = AppData as AppSetup;
    const vodInfo: ItemNode = this.gridViewModel.getFocusedItem();
    Log.info('MLPGridTemplateSpec:_gridFocusedHandler: ', this.gridViewModel.getFocusInfo(), vodInfo)
    this.patch({
      ItemInfo: {
        item: vodInfo,
      }
    })
    this.autoPlay && this.autoPlay?.userInteracted(true)
    platform?.textToSpeach(`${vodInfo.title}  ${vodInfo.description}`)
  }

  override _handleBack(e?: KeyboardEvent): boolean | void {
    Log.info('MLPGridTemplateSpec:_handleBack ')
    const { appState, platform } = AppData as AppSetup
    const app = appState?.getApp()
    if (this.autoPlay && !this.autoPlayStoppedByBack) {
      this.autoPlay.registerBackPress();
      this.updateAutoPlayVideo(false)
      this.autoPlay?.stop()
      this.autoPlayStoppedByBack = true
      Log.info('MLPGrid:_handleBack - autoplay stopped, press back again to focus Menu')
      Logger.processUserAction('mlpAutoplayStopped', '')
      // return true
    }
    platform?.textToSpeach('Closing')
    this.tag('MultiRowGrid')?.clearGrid()
    Registry.setTimeout(() => {
      app?.handleBackNavigation()
    }, 100)
    return true
  }

  _gridSelectedHandler(event: any) {
    const vodInfo: ItemNode = this.gridViewModel.getFocusedItem();
    const { appState, platform } = AppData as AppSetup
    const app = appState?.getApp()
    Log.info('MLPGridTemplateSpec:_gridSelectedHandler: ', this.gridViewModel.getFocusInfo(), vodInfo)
    this.autoPlay?.userInteracted(false)
    if (app?.blockingManager.checkAndShowAgeRatingPopup(vodInfo, this._handleSimpleAgeRestrictionCallback.bind(this))) {
      return;
    }
    // if (app?.blockingManager.isItemBlocked(vodInfo)) {
    //   this.widgets.notification.showMessage('')
    //   return;
    // }
    if (vodInfo.blockItem) {
      const dialogInfo: IDialogueInfo = {
        title: 'Uh-Oh',
        body: 'Please unblock to play content',
        type: DIALOG_TYPE.ALERT,
        buttons: [
          {
            w: 200,
            name: 'OK',
            index: 0,
            action: DIALOG_BUTTON_ACTION.CLOSE,
            initialFocus: true,
          }
        ]
      }
      this.widgets.dialog.showDialog(dialogInfo)
      Router.focusWidget('dialog')
      return true
    }
    platform?.textToSpeach(`Playing ${vodInfo.title}`)
    this.checkBookmarkOrVideoResume(vodInfo)
    /*if (vodInfo.type == 'listoflist' || vodInfo.type == 'new-qid' || vodInfo.feed_type == 'banner') {
      Logger.processUserAction('showClickedOnGrid',vodInfo.id);
      //Router.navigate(`mlp-grid-screen/${vodInfo.id}`, false)
      this._handleBookmarking(vodInfo)
    } else if (vodInfo.feed_type == 'video') {
      Logger.processUserAction('videoItemSelectedFromListoflistGrid',vodInfo.node_id);
      this._handleVideoResume(vodInfo)
      //Router.navigate('video-screen/'+vodInfo.node_id+'_resume', false)
    }*/
  }

  _handleSimpleAgeRestrictionCallback(actionBtn: any, dialogInfo: IDialogueInfo) {
    //console.log('_handleSimpleAgeRestrictionCallback: ', actionBtn.action)
    const { appState, appConfig } = AppData as AppSetup
    const app = appState?.getApp()
    if (actionBtn.action == DIALOG_BUTTON_ACTION.YES) {
      this.checkBookmarkOrVideoResume(dialogInfo.callbackData)
    } else if (actionBtn.action == DIALOG_BUTTON_ACTION.NO) {
      app?.navigation.reset()
      appConfig.aContent = false
      Router.navigate('main-grid-screen/' + app?.l1CategoryToLoad + '_true', false)
    } else if (actionBtn.action == DIALOG_BUTTON_ACTION.CLOSE) {
      //reset the isAgePopupShown to false as the user have not select any options. 
      appConfig.isAgePopupShown = false;
    }
  }

  _handleBookmarking(vodInfo) {
    this.widgets.bookmark.$setbdata(vodInfo)
    Router.focusWidget('Bookmark')
  }

  _handleVideoResume(vodInfo) {
    const { appConfig, appState, platform } = AppData as AppSetup;
    const appApiConfig = appState?.getAppApiConfig()
    let resumeTime = null
    if (appConfig?.useLocalStorage == true) {
      resumeTime = localStorage.getItem(vodInfo.node_id)!;
    } else {
      resumeTime = Helper.getCookie(vodInfo.node_id);
    }

    if (resumeTime !== "" && resumeTime !== null && resumeTime !== 0 && resumeTime !== '0' && (appApiConfig?.appConfig?.resumeVidMinDuration && vodInfo.runtime > appApiConfig?.appConfig?.resumeVidMinDuration)) {
      platform?.textToSpeach('Do you want to resume Video session')
      this.widgets.bookmark.$setbdata(vodInfo)
      Router.focusWidget('Bookmark')
    } else {
      Router.navigate('video-screen/' + vodInfo.node_id + '_resume', false)
    }
  }

  /**
   * @method launchChildApp
   * @description Open the site behind an "app suggestions" tile inside the app, reusing the
   * same child-app stack the bug-ad launchInAppOpening action uses: a fresh AppModel for the
   * target site is pushed on appState.appStack and the router lands on that site's main grid.
   * The hero preview is torn down first so nothing keeps playing across the switch.
   * @param {ItemNode} vodInfo - The focused childapp node, carrying the target site_id.
   * @returns {boolean} true when the site switch was started.
   */
  launchChildApp(vodInfo: ItemNode): boolean {
    const { appState, platform } = AppData as AppSetup
    const app = appState?.getApp()
    const siteId = vodInfo?.site_id ? String(vodInfo.site_id) : ''

    if (!Helper.isValidValue(siteId) || siteId == '0') {
      Log.error('MLPGridTemplateSpec: launchChildApp - invalid site id for', vodInfo?.title, siteId)
      return false
    }

    const targetSiteId = platform ? platform.remapSiteId(siteId) : siteId
    if (app?.siteId == targetSiteId) {
      Log.info('MLPGridTemplateSpec: launchChildApp - already running site', targetSiteId)
      return false
    }

    Logger.processUserAction('newChildAppOpenedOnGrid', siteId)

    // Stop the grid preview before leaving - the page detaches asynchronously.
    this.autoPlay?.userInteracted(false)
    this.updateAutoPlayVideo(false)

    childApp.loadChildApp({ site_id: siteId })
    return true
  }

  /**
   * Handler to show bookmark screen or video resume screen.
   * @param {number} vodInfo - Video info.
   * @returns - NA
   */
  checkBookmarkOrVideoResume(vodInfo, force = false) {
    if (Helper.isChildAppItem(vodInfo)) {
      this.launchChildApp(vodInfo)
      return;
    }
    if (force) {
      this.widgets.moreinfo.$setbdata(vodInfo)
      Router.focusWidget('Moreinfo')
      return;
    }
    this.autoPlay && this.autoPlay.userInteracted(false)
    if (vodInfo.type == 'listoflist' || vodInfo.type == 'new-qid' || vodInfo.feed_type == 'banner') {
      Logger.processUserAction('showClickedOnGrid', vodInfo.id);
      //Router.navigate(`mlp-grid-screen/${vodInfo.id}`, false)
      this._handleBookmarking(vodInfo)
    } else if (vodInfo.feed_type == 'video') {
      this.widgets.loadingscreen.showVideoLoadingScreen(true)
      Logger.processUserAction('videoItemSelectedFromListoflistGrid', vodInfo.node_id);
      this._handleVideoResume(vodInfo)
      //Router.navigate('video-screen/'+vodInfo.node_id+'_resume', false)
    } else if (vodInfo.feed_type == 'live') {
      Logger.processUserAction('videoItemSelectedFromListoflistGrid', vodInfo.node_id);
      // Live has no hero preview stage, so autoplay would drag the user straight back into the
      // channel they just backed out of. Consume it for this session on manual play too.
      this.autoPlay?.markAutoplayIgnored(vodInfo)
      Router.navigate('video-screen-live/' + vodInfo.node_id, false)
    }
  }

  override _onDataProvided() {
    const { appState } = AppData as AppSetup
    const app = appState?.getApp()
    const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!
    const channel = appApiConfig?.appConfig?.channels?.[app?.l1CategoryToLoad] ?? null
    const bgImage = (channel?.bg_image) || Utils.asset('/images/info_bg-236.png')

    Log.info('MLPGridTemplateSpec: _onDataProvided fired')

    this.patch({
      ItemInfo: {
        background: bgImage,
      },
    })

    this.gridViewModel.on('loaded', this._gridLoadedHandler, this)
    this.gridViewModel.on('focused', this._gridFocusedHandler, this)
    this.gridViewModel.on('selected', this._gridSelectedHandler, this)
    this.gridViewModel._init()

    this.widgets.loadingscreen.showL1LoadingScreen(true)
  }

  /**
  * @method initAutoplay
  * @description Initialize the autoplay feature for the mlp.
  * 
  */
  initAutoplay() {
    const { appState, appConfig } = AppData as AppSetup;
    const appApiConfig = appState?.getAppApiConfig()
    const autoplayTimer = appApiConfig?.appConfig?.autoplayTimer * 1000

    const mlpAutoplay = appApiConfig?.appConfig?.mlpAutoplay;
    const enableTrailer = appApiConfig?.appConfig?.enableTrailer;

    if ((mlpAutoplay && appConfig?.enableAutoplay) || (enableTrailer && (appConfig?.enableAutoplay || appConfig?.enableTrailer))) {
      this.autoPlay = new Autoplay({
        gridDelay: autoplayTimer,
        stopOnInteraction: false,
        gridType: 'mlp'
      })
      this.autoPlay.on('onStart', () => {
        Log.info('MLPGrid: onStart')
      })
      this.autoPlay.on('onGridAutoplay', (vodInfo, heroPreview) => {
        Log.info('MLPGrid: onGridAutoplay started',vodInfo, heroPreview)
        this.autoPlayStoppedByBack = false
        this.updateAutoPlayVideo(true)
        if (heroPreview?.playShorts) {
          Logger.processUserAction('shortsStarted', vodInfo.node_id);
        } else if (heroPreview?.playTrailer) {
          Logger.processUserAction('trailerStarted', vodInfo.node_id);
        } else {
          Logger.processUserAction('mlpAutoplayStarted', vodInfo.node_id)
        }
      })
      this.autoPlay.on('onVideoAutoplay', (vodInfo) => {
        Log.info('MLPGrid: onVideoAutoplay started', vodInfo)
        if (Helper.isChildAppItem(vodInfo)) {
          Log.info('MLPGrid: onVideoAutoplay skipped for childapp item', vodInfo?.site_id)
          return
        }
        if (vodInfo.feed_type == 'live') {
          Logger.processUserAction('liveAutoplayStarted', vodInfo.node_id)
          Router.navigate('video-screen-live/' + vodInfo.node_id, false)
        } else {
          Router.navigate('video-screen/' + vodInfo.node_id + '_resume', false)
        }
      })
      this.autoPlay.on('onAutoplayStopped', (vodInfo, heroPreview) => {
        Log.info('MLPGrid: onAutoplayStopped', heroPreview)
        this.updateAutoPlayVideo(false)
        if (vodInfo) {
            if (heroPreview?.playShorts) {
                Logger.processUserAction('shortsStopped', vodInfo.node_id);
            } else if (heroPreview?.playTrailer) {
                Logger.processUserAction('trailerStopped', vodInfo.node_id);
            } else {
                Logger.processUserAction('mlpAutoplayStopped', vodInfo.node_id);
            }
        }
      })
    }
  }

  override _init() {
    this.patch({
      ItemInfo: {
        isMlpScreen: true,
      },
    })
    // this._squareLogo()
    // this.tag("BackBar.Icon").patch({
    //   texture: {
    //     src: Utils.asset('/images/ico-back.png'),
    //     resizeMode: { h: 48, w: 48, type: 'contain' },
    //     type: Lightning.textures.ImageTexture
    //   }
    // })
  }

  // _squareLogo() {
  //   const { appState } = AppData as AppSetup
  //   const app = appState?.getApp()
  //   const square_icon = app?.appApiConfig?.appConfig?.square_icon
  //   this.tag("BackBar.SquareIcon").patch({
  //     texture: {
  //       src: square_icon,
  //       resizeMode: {
  //         h: 60,
  //         w: 60,
  //         type: 'contain'
  //       },
  //       type: Lightning.textures.ImageTexture
  //     }
  //   })
  // }

  /**
     * @method updateAutoPlayVideo
     * @description Update the video playing status for autoplay.
     * @param {boolean} statusVideoPlaying - Video playing status.
     * @returns - NA
     * 
     */

  updateAutoPlayVideo(statusVideoPlaying = false) {
    if (statusVideoPlaying) {
      this.patch({
        color: 0x00222222,
        Background: {
          color: 0x00222222,
        },
        ItemInfo: {
          gridVideoPlaying: true,
        }
      })
    } else {
      this.patch({
        color: 0xff222222,
        Background: {
          color: 0xff222222,
        },
        ItemInfo: {
          gridVideoPlaying: false,
        }
      })
    }
  }

  /**
  * @method resetAutoplay
  * @description Reset the autoplay feature by removing all event listeners and destroying the instance.
  * 
  */
  resetAutoplay() {
    if (this.autoPlay) {
      this.autoPlay.off('onStart');
      this.autoPlay.off('onGridAutoplay');
      this.autoPlay.off('onVideoAutoplay');
      this.autoPlay.off('onAutoplayStopped');
      this.autoPlay.destroy();
      this.autoPlay = null;
    }
  }

  $handleLongEnter() {
    Log.info('MlpGrid:', '_handleLongPress')
    Router.focusWidget('OptionsMenu')
  }

  $handleBackButton() {
    this._handleBack()
  }

  _handleClick(e) {
    Log.info('MlpGrid:', '_handleClick', e)
    if (e && e.__ref && e.__ref == 'Icon') {
      this._handleBack()
    }
  }

  _handleScroll(obj: any): boolean | void {
    const multiRowGrid = this.tag('MultiRowGrid') as any
    if (obj?.wheelDeltaY && obj.wheelDeltaY > 0) {
      multiRowGrid?.onUp()
    } else {
      multiRowGrid?.onDown()
    }
    return true
  }

  override _detach(): void {
    clearTimeout(this.loadingTimeoutId);
    // Remove event listeners from gridViewModel
    if (this.gridViewModel) {
      this.gridViewModel.off('loaded', this._gridLoadedHandler, this);
      this.gridViewModel.off('focused', this._gridFocusedHandler, this);
      this.gridViewModel.off('selected', this._gridSelectedHandler, this);
    }
    // Remove Autoplay event listeners
    this.resetAutoplay()
  }
}
